@if (loginError$ | async) {
  <ng-container></ng-container>
}
@if (isAuthenticated$ | async) {
} @else {
  <ng-container *ngTemplateOutlet="userNotLoggedIn"></ng-container>
}
<ng-template #userNotLoggedIn>
  <lib-landing (signInClick)="login()" [landingImageUrl]="landingImageURL"></lib-landing>
</ng-template>

<ng-template #loginErrorTemplate>
  <div class="login-error-support">
    @if (isProdOrDemo) {
      <!-- Production or Demo Environments -->
      <p>
        It looks like your profile is missing some information needed to sign you in. Please create a support ticket and
        we will help resolve the issue.
      </p>
    } @else {
      <!-- Lower Environments -->
      <p>
        @if (LoginErrorCode === 'Unknown') {
          <!-- General Message for Unknown Errors -->
          We ran into an unexpected issue while signing you in. Please create a support ticket by clicking the on the
          Create ticket button and following these instructions:
        } @else {
          <!-- Specific Error Code -->
          It looks like your profile is missing some information needed to sign you in. Please create a support ticket
          by clicking the on the Create ticket button and following these instructions:
        }
      </p>
      <ul>
        <li>Enter data in all required fields (minimally, all fields with an asterisk (*) must be populated).</li>
        <li>You should put any helpful details in the 'Description' field.</li>
        <li>
          Include in the Description field the text: "Please route this incident to the <b>APPCIAMTier3</b>
          team/Assignment Group".
        </li>
        <li>
          If you need the priority/urgency on the incident to be increased, include this in the Description field as
          well: Please raise the Urgency on this incident to be 2.
        </li>
      </ul>
    }
  </div>
</ng-template>
